import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ButtonVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info';
export type ButtonSize = 'sm' | 'md' | 'lg';
export type IconPosition = 'left' | 'right';

@Component({
  selector: 'app-custom-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-button.html',
  styleUrls: ['./custom-button.css']
})
export class CustomButtonComponent {
  @Input() text: string = '';
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() icon: string = ''; // SVG string, emoji, o material icon
  @Input() iconPosition: IconPosition = 'left';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  // Colores personalizados (opcional)
  @Input() backgroundColor: string = '';
  @Input() textColor: string = '';
  @Input() borderColor: string = '';
  @Input() hoverBackgroundColor: string = '';
  @Input() hoverTextColor: string = '';

  @Output() click = new EventEmitter<Event>();

  onClick(event: Event) {
    if (!this.disabled && !this.loading) {
      this.click.emit(event);
    }
  }

  get buttonClasses(): string {
    const classes = ['custom-button'];

    // Variante del botón
    classes.push(`btn-${this.variant}`);

    // Tamaño del botón
    classes.push(`btn-${this.size}`);

    // Estados
    if (this.disabled) classes.push('btn-disabled');
    if (this.loading) classes.push('btn-loading');
    if (this.fullWidth) classes.push('btn-full-width');
    if (this.hasCustomColors) classes.push('btn-custom-colors');

    return classes.join(' ');
  }

  get hasCustomColors(): boolean {
    return !!(this.backgroundColor || this.textColor || this.borderColor);
  }

  get customStyles(): any {

    const styles: any = {};

    if (this.backgroundColor) styles['background-color'] = this.backgroundColor;
    if (this.textColor) styles['color'] = this.textColor;
    if (this.borderColor) styles['border-color'] = this.borderColor;

    if (this.hoverBackgroundColor) {
      styles['--hover-bg'] = this.hoverBackgroundColor;
    }
    if (this.hoverTextColor) {
      styles['--hover-text'] = this.hoverTextColor;
    }

    return styles;
  }
}
